(function () {
  function boot() {
    if (window.__p26init) return;
    window.__p26init = 1;
    var root = document;

    /* reset stuck buy buttons + busy flag after back-navigation (bfcache) */
    window.addEventListener('pageshow', function () {
      window.__p26busy = 0;
      document.querySelectorAll('.p26-btn.loading').forEach(function (b) { b.classList.remove('loading'); });
    });

    /* ---------- smart video playback (mobile-first) ----------
       Every .p26 video ships with preload="metadata" so nothing fights for
       bandwidth on page load. The moment a video nears the viewport this
       observer bumps it to full buffering and calls play() explicitly —
       relying on the bare autoplay attribute alone is unreliable deep in a
       long page on mobile Safari/Chrome. Videos scrolled out of view are
       paused so only what's on screen is actively downloading/decoding. */
    var p26Vids = document.querySelectorAll('.p26 video');
    if ('IntersectionObserver' in window && p26Vids.length) {
      var p26Vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload !== 'auto') v.preload = 'auto';
            v.muted = true;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '300px 0px', threshold: 0.05 });
      p26Vids.forEach(function (v) { p26Vio.observe(v); });
    }

  /* ---------- evergreen countdown (to local midnight) ---------- */
  var cds = document.querySelectorAll('[data-cd]');
  if (cds.length) {
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      var d = Math.max(0, end - now);
      var h = Math.floor(d / 3600000), m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      cds.forEach(function (el) { el.textContent = txt; });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- live phone demos ---------- */
  var phones = root.querySelector('[data-phones]');
  var famsWrap = root.querySelector('[data-fams]');
  function loadFam(session) {
    if (!phones) return;
    phones.querySelectorAll('iframe').forEach(function (fr) {
      fr.src = 'https://elevateaistore.co/preview/' + encodeURIComponent(session) + '/native/' + fr.dataset.page;
    });
  }
  if (famsWrap) {
    famsWrap.querySelectorAll('.p26-fam').forEach(function (b) {
      b.addEventListener('click', function () {
        famsWrap.querySelectorAll('.p26-fam').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        loadFam(b.dataset.session);
      });
    });
    /* each demo iframe loads a whole separate storefront — only fetch once the
       section is actually about to be seen, not at page boot */
    var first = famsWrap.querySelector('.p26-fam.on');
    var demoSection = document.getElementById('demos');
    if (first && demoSection) {
      if ('IntersectionObserver' in window) {
        var demoIo = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { loadFam(first.dataset.session); demoIo.disconnect(); } });
        }, { rootMargin: '600px 0px' });
        demoIo.observe(demoSection);
      } else {
        loadFam(first.dataset.session);
      }
    }
  }

  /* ---------- sticky bar ---------- */
  var sticky = root.querySelector('[data-sticky]');
  var buySec = document.getElementById('buy');
  var finalSec = document.getElementById('final');
  function updSticky() {
    if (!sticky || !buySec) return;
    var past = buySec.getBoundingClientRect().bottom < 0;
    var before = true;
    if (finalSec) before = finalSec.getBoundingClientRect().top > window.innerHeight * 0.7;
    var on = past && before;
    sticky.classList.toggle('on', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  window.addEventListener('scroll', updSticky, { passive: true });
  updSticky();

  /* ---------- smooth anchors ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

    /* everything below needs the buy section */
    var cfg = document.getElementById('p26-data');
    if (!cfg) return;

  /* ---------- money ---------- */
  var moneySample = cfg.dataset.money;
  var moneyDec = moneySample.indexOf('0,00') > -1 ? ',' : '.';
  var moneyThou = moneyDec === ',' ? '.' : ',';
  var moneyFmt = moneySample.indexOf('0.00') > -1 ? moneySample.replace('0.00', '{{amount}}')
    : moneySample.indexOf('0,00') > -1 ? moneySample.replace('0,00', '{{amount}}')
    : moneySample.replace('0', '{{amount}}');
  function fmt(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2).replace('.', moneyDec);
    var parts = s.split(moneyDec);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyThou);
    s = parts.join(moneyDec);
    return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  /* ---------- media carousel ---------- */
  var stage = root.querySelector('[data-stage]');
  function syncThumb(i) {
    root.querySelectorAll('.p26-thumb').forEach(function (x, n) { x.classList.toggle('on', n === i); });
  }
  function curSlide() {
    return stage ? Math.round(stage.scrollLeft / stage.clientWidth) : 0;
  }
  function goSlide(i) {
    if (!stage) return;
    var max = stage.children.length - 1;
    i = Math.max(0, Math.min(i, max));
    stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    syncThumb(i);
  }
  root.querySelectorAll('.p26-thumb').forEach(function (t) {
    t.addEventListener('click', function () { goSlide(+t.dataset.goto); });
  });
  root.querySelectorAll('[data-snav]').forEach(function (b) {
    b.addEventListener('click', function () { goSlide(curSlide() + (+b.dataset.snav)); });
  });
  if (stage) {
    var st;
    stage.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { syncThumb(curSlide()); }, 90);
    }, { passive: true });
  }

  /* ---------- offer state ---------- */
  var baseCents = +cfg.dataset.base;
  var TH = cfg.dataset.th.split(',').map(Number); /* [base, 10%-off spend threshold, CRO-call spend threshold] */
  var state = { ads: false, adsVid: 0, adsCents: 0, adsLabel: '', lic: 0 };
  var firstVar = root.querySelector('[data-ads-var]');
  if (firstVar) { state.adsVid = +firstVar.dataset.vid; state.adsCents = +firstVar.dataset.cents; state.adsLabel = firstVar.dataset.label; }

  /* licence volume: native Shopify automatic discounts on the SAME £150 variant —
     qty 2 = 20% off order, qty 3+ = 30% off order. Mirrored here for display only. */
  function licRatePct(qty) { return qty >= 3 ? 30 : qty >= 2 ? 20 : 0; }

  function calc() {
    var qty = 1 + state.lic;
    var licSubtotal = baseCents * qty;
    var licRate = licRatePct(qty) / 100;
    var licDiscAmt = Math.round(licSubtotal * licRate);
    var adsCents = state.ads ? state.adsCents : 0;
    var spend = licSubtotal + adsCents; /* pre-discount cart value — what Shopify's minimums check against */
    var orderDiscAmt = spend >= TH[1] ? Math.round(spend * 0.10) : 0;
    /* Shopify applies exactly one non-combining order discount: whichever is larger */
    var bestIsOrder = orderDiscAmt >= licDiscAmt && orderDiscAmt > 0;
    var bestDiscAmt = bestIsOrder ? orderDiscAmt : licDiscAmt;
    return {
      qty: qty, licSubtotal: licSubtotal, licRate: licRatePct(qty), licDiscAmt: licDiscAmt,
      adsCents: adsCents, spend: spend, orderDiscAmt: orderDiscAmt,
      bestIsOrder: bestIsOrder, bestDiscAmt: bestDiscAmt, paid: spend - bestDiscAmt
    };
  }
  function total() { return calc().paid; }

  function paint() {
    var c = calc();
    var el = root.querySelector('[data-total]');
    if (el) el.textContent = '— ' + fmt(c.paid);
    var mini = root.querySelector('[data-total-mini]');
    if (mini) mini.textContent = fmt(c.paid);

    /* licence stepper */
    var cnt = root.querySelector('[data-lic-count]');
    if (cnt) cnt.textContent = state.lic;
    var sum = root.querySelector('[data-lic-sum]');
    if (sum) {
      sum.hidden = state.lic === 0;
      if (state.lic > 0) {
        sum.innerHTML = c.licRate > 0
          ? c.qty + ' licences: ' + fmt(c.licSubtotal - (c.bestIsOrder ? 0 : c.licDiscAmt)) + ' <s>' + fmt(c.licSubtotal) + '</s> — ' + c.licRate + '% off, applied automatically'
          : c.qty + ' licences — add 1 more to unlock 20% off your order';
      }
    }

    /* checkpoint bar — gated on pre-discount spend, matches Shopify's own minimum-purchase check */
    var seg = 0;
    while (seg < 2 && c.spend >= TH[seg + 1]) seg++;
    var frac = seg >= 2 ? 0 : Math.max(0, (c.spend - TH[seg]) / (TH[seg + 1] - TH[seg]));
    var pct = Math.min(100, (seg + frac) / 2 * 100);
    var fill = root.querySelector('[data-goal-fill]');
    if (fill) fill.style.width = pct + '%';
    root.querySelectorAll('.p26-goal-node').forEach(function (node) {
      node.classList.toggle('on', c.spend >= TH[+node.dataset.node]);
    });
    root.querySelectorAll('[data-glabel]').forEach(function (l) {
      l.classList.toggle('on', c.spend >= TH[+l.dataset.glabel]);
    });
    var note = root.querySelector('[data-goal-note]');
    if (note) {
      if (c.spend >= TH[2]) {
        note.innerHTML = '<b>Maxed out:</b> ' + (c.licDiscAmt > c.orderDiscAmt ? c.licRate + '% off your order' : '10% off') + ' + a <b>free 1-on-1 pro CRO strategy call</b> — we email you to book.';
      } else if (c.spend >= TH[1]) {
        note.innerHTML = (c.bestIsOrder ? '<b>10% off unlocked</b> — applied at checkout.' : '<b>' + c.licRate + '% off your order</b> — applied automatically.') + ' ' + fmt(TH[2] - c.spend) + ' more for a <b>free pro CRO strategy call</b>.';
      } else {
        note.innerHTML = 'Add ' + fmt(TH[1] - c.spend) + ' more to unlock <b>10% off your whole order</b>.';
      }
    }

    /* order-includes dynamic pills */
    function dyn(key, on) { var li = root.querySelector('[data-dyn="' + key + '"]'); if (li) li.hidden = !on; }
    dyn('ads', state.ads);
    var al = root.querySelector('[data-dyn-ads-label]');
    if (al) al.textContent = state.adsLabel + ' custom static ads';
    dyn('lic', state.lic > 0);
    var ll = root.querySelector('[data-dyn-lic-label]');
    if (ll) ll.textContent = '+' + state.lic + ' extra licence' + (state.lic > 1 ? 's' : '');
    var ls = root.querySelector('[data-dyn-lic-stores]');
    if (ls) ls.textContent = c.qty + ' live stores total';
    dyn('r1', c.bestIsOrder);
    dyn('r3', c.spend >= TH[2]);

    /* dark summary lines */
    function sline(sel, show) { var el = root.querySelector(sel); if (el) el.hidden = !show; return el; }
    var sBaseLabel = root.querySelector('[data-sum-base-label]');
    var sBasePrice = root.querySelector('[data-sum-base-price]');
    if (sBaseLabel) sBaseLabel.textContent = c.qty > 1 ? c.qty + ' × 26 themes + AI builder' : '26 themes + AI builder';
    if (sBasePrice) sBasePrice.textContent = fmt(c.licSubtotal);
    var sa = sline('[data-sum-ads]', state.ads);
    if (sa && state.ads) {
      sa.querySelector('[data-sum-ads-label]').textContent = 'Custom static ads · ' + state.adsLabel;
      sa.querySelector('[data-sum-ads-price]').textContent = fmt(state.adsCents);
    }
    var sl = sline('[data-sum-lic]', state.lic > 0 && !c.bestIsOrder && c.licDiscAmt > 0);
    if (sl) {
      sl.querySelector('[data-sum-lic-label]').textContent = c.qty + ' licences — ' + c.licRate + '% off order (automatic)';
      sl.querySelector('[data-sum-lic-price]').textContent = '−' + fmt(c.licDiscAmt);
    }
    var so = sline('[data-sum-off]', c.bestIsOrder);
    if (so) so.querySelector('[data-sum-off-price]').textContent = '−' + fmt(c.orderDiscAmt);
    sline('[data-sum-cro]', c.spend >= TH[2]);
    var stt = root.querySelector('[data-sum-total]');
    if (stt) stt.textContent = fmt(c.paid);

    /* ads row price reflects selected variant */
    var ap = root.querySelector('[data-ads-price]');
    if (ap) ap.innerHTML = '+' + fmt(state.adsCents);
  }

  var adsCheck = root.querySelector('[data-ads-check]');
  if (adsCheck) adsCheck.addEventListener('change', function () { state.ads = this.checked; paint(); });
  root.querySelectorAll('[data-ads-var]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-ads-var]').forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      state.adsVid = +b.dataset.vid; state.adsCents = +b.dataset.cents; state.adsLabel = b.dataset.label;
      state.ads = true;
      if (adsCheck) adsCheck.checked = true;
      paint();
    });
  });
  var licMinus = root.querySelector('[data-lic-minus]');
  var licPlus = root.querySelector('[data-lic-plus]');
  if (licPlus) licPlus.addEventListener('click', function () { state.lic = Math.min(state.lic + 1, 10); paint(); });
  if (licMinus) licMinus.addEventListener('click', function () { state.lic = Math.max(state.lic - 1, 0); paint(); });
  paint();

  /* ---------- buy ----------
     Mobile browsers (Safari especially, and in-app browsers like
     Instagram/TikTok worse still) only reliably allow a tap to trigger
     navigation if it happens IMMEDIATELY, synchronously, in response to
     that tap. The old flow waited on two chained fetches (clear, then
     add) before setting location.href — by the time both round trips
     finished, the browser had often decided the tap was too far in the
     past and silently blocked the redirect. Fix: submit a real <form>
     synchronously (zero async gap, immune to that entire bug class) and
     let Shopify's own return_to handle the redirect to checkout. The
     cart is kept clear proactively (on load + on bfcache restore) so no
     clear() call needs to sit in the critical click-to-navigate path. */
  var checkoutForm = document.getElementById('p26-checkout-form');
  function clearCart() {
    try { fetch('/cart/clear.js', { method: 'POST', keepalive: true }); } catch (_) {}
  }
  clearCart();
  window.addEventListener('pageshow', function (e) { if (e.persisted) clearCart(); });

  function buy(btn) {
    if (window.__p26busy) return;
    window.__p26busy = 1;
    btn.classList.add('loading');
    try { if (typeof fbq === 'function') fbq('track', 'InitiateCheckout', { value: total() / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }); } catch (_) {}
    var mainVid = +root.querySelector('[data-buy]').dataset.mainVid;
    var c = calc();
    var dest = c.bestIsOrder ? '/discount/ELEVATE10?redirect=/checkout' : '/checkout';
    /* ads add-on rides along as a best-effort parallel add — it only ever
       adds a line, never removes one, so it can't race-corrupt the cart
       the way a parallel clear() could */
    if (state.ads && state.adsVid) {
      try {
        fetch('/cart/add.js', {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: state.adsVid, quantity: 1 }] })
        });
      } catch (_) {}
    }
    if (checkoutForm) {
      checkoutForm.querySelector('[data-cf-id]').value = mainVid;
      checkoutForm.querySelector('[data-cf-qty]').value = c.qty;
      checkoutForm.querySelector('[data-cf-return]').value = dest;
      checkoutForm.submit();
    } else {
      window.location.href = '/cart/' + mainVid + ':' + c.qty;
    }
  }
  var buyBtn = root.querySelector('[data-buy]');
  if (buyBtn) buyBtn.addEventListener('click', function () { buy(this); });
  var stickyBuy = root.querySelector('[data-buy-sticky]');
  if (stickyBuy) stickyBuy.addEventListener('click', function () { buy(this); });

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
